import React, { useState, useEffect } from 'react';
import Soundfont, { InstrumentName } from 'soundfont-player';
import { PianoRollKeybed } from '../../rolls/PianoKeybed';
import { SoundfontInstrumentSelectionDialog } from '../../dialogs/InstrumentSelectionDialog';
import { RydTrack } from '../../../model/tracks';


const SoundfontSynth: React.FC = ({
    track,
    audioContext,
} : {
    track: RydTrack,
    audioContext: AudioContext;
}) => {
    const [instrument, setInstrument] = useState<Soundfont.Player | null>(null);
    const [instrumentName, setInstrumentName] = useState<InstrumentName>(); // Default to the first instrument

    useEffect(() => {
        if (!instrumentName) return;
        // Load the "acoustic_grand_piano" soundfont. You can change to any available instrument.

        // https://gleitz.github.io/midi-js-soundfonts/MusyngKite/names.json
        //'acoustic_grand_piano'
        Soundfont.instrument(audioContext, instrumentName)
            .then((inst) => setInstrument(inst))
            .catch((err) => console.error('Error loading instrument:', err));
    }, [instrumentName]);

    const playNote = (note: string) => {
        if (instrument) {
            // Play the note for 1 second. Adjust options as needed.
            instrument.play(note, audioContext.currentTime, { duration: 1 });
        }
    };

    return (
        <div className='ryd-instrument-wrapper' style={{ padding: '5px' }}>
            <div style={{ marginBottom: '10px' }}>
                {/* <label htmlFor="instrument-select">Instrument:&nbsp;</label>
                <select
                    id="instrument-select"
                    value={instrumentName || 'acoustic_grand_piano'}
                    onChange={(e) => setInstrumentName(e.target.value as InstrumentName)}
                >
                    {listSoundfondInstruments().map((instrument: RydInstrument, i: number) => (
                        <option key={i} value={instrument.id}>
                            {instrument.name}
                        </option>
                    ))}
                </select> */}
                <SoundfontInstrumentSelectionDialog
                    setInstrument={(selectedInstrument: InstrumentName) => {
                        setInstrumentName(selectedInstrument);
                        // Reset the instrument to trigger loading
                        setInstrument(null);
                    }}
                />
            </div>
            <PianoRollKeybed
                track={track}
                noteRange={{ min: 24, max: 24 + (3 * 12) }}
                showOctave={true}
                orientation={'keyboard'}
                tonality={undefined}
                noteActivityObserver={undefined}
                stylingSource={undefined}
                triggerCB={(note) => playNote(note.getName())}
            />

        </div>
    );
};

export { SoundfontSynth };